import { render, staticRenderFns } from "./Accesorios.vue?vue&type=template&id=07c9d9bb&"
import script from "./Accesorios.vue?vue&type=script&lang=js&"
export * from "./Accesorios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports